import { useState } from "react";
import Box from "@mui/material/Box";
import CardMedia from "../../../../../components/Media/CardMedia";
import ModalMedia from "../../../../../components/Modal/ModalMedia";
import { VIDEO } from "../../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../../lib/i18next";
import { getExtensionFile } from "../../../../../utils/string";
import { VIDEO_FORMATS } from "../../../../../utils/constants";
import { PERFORMING_ASSETS_HAIRLINE } from "./performingAssetsStyles";

const VIDEO_CHIP_SX = {
  position: "absolute",
  left: 10,
  bottom: 10,
  zIndex: 1,
  px: 1,
  py: 0.25,
  borderRadius: 999,
  bgcolor: "rgba(15, 23, 42, 0.72)",
  color: "#fff",
  fontSize: "0.6875rem",
  fontWeight: 600,
  pointerEvents: "none",
};

const isPdfExportDocument = () =>
  document.documentElement.classList.contains("pdf-export");

const PerformingAssetsCreative = ({ url }) => {
  const { t } = useTranslationApp();
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const isPdfExport = isPdfExportDocument();

  if (!url) return null;

  const onOpenPreview = () => setIsPreviewOpen(true);
  const onClosePreview = () => setIsPreviewOpen(false);
  const isVideo = VIDEO_FORMATS.includes(getExtensionFile(url));

  if (isVideo && isPdfExport) {
    return (
      <Box
        sx={{
          position: "relative",
          width: "100%",
          maxWidth: 360,
          bgcolor: "#F5F5F5",
          borderRadius: 2.5,
          overflow: "hidden",
          border: `1px solid ${PERFORMING_ASSETS_HAIRLINE}`,
        }}
      >
        <Box
          component="video"
          data-pdf-video
          src={url}
          muted
          playsInline
          preload="metadata"
          sx={{
            width: "100%",
            maxHeight: 220,
            display: "block",
            objectFit: "contain",
            bgcolor: "#F5F5F5",
          }}
        />
      </Box>
    );
  }

  if (isVideo) {
    return (
      <Box
        sx={{
          position: "relative",
          width: "100%",
          bgcolor: "#0B1220",
          borderRadius: 2.5,
          overflow: "hidden",
          border: `1px solid ${PERFORMING_ASSETS_HAIRLINE}`,
        }}
      >
        <Box component="span" sx={VIDEO_CHIP_SX}>
          {t(VIDEO)}
        </Box>
        <CardMedia
          url={url}
          sx={{
            width: "100%",
            maxHeight: 220,
            display: "block",
            objectFit: "contain",
            bgcolor: "#0B1220",
          }}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ display: "flex", justifyContent: "flex-start" }}>
      <Box
        component="button"
        type="button"
        onClick={onOpenPreview}
        sx={{
          position: "relative",
          display: "block",
          maxWidth: "100%",
          p: 0,
          border: `1px solid ${PERFORMING_ASSETS_HAIRLINE}`,
          borderRadius: 2.5,
          overflow: "hidden",
          cursor: "pointer",
        }}
      >
        <CardMedia
          url={url}
          eager={isPdfExport}
          sx={{
            width: "auto",
            maxWidth: "100%",
            height: 188,
            display: "block",
          }}
        />
      </Box>

      {isPreviewOpen ? (
        <ModalMedia
          modalOpen={isPreviewOpen}
          onCloseModal={onClosePreview}
          url={url}
          showEditButton={false}
          showShareButton={false}
          showDownloadButton={false}
        />
      ) : null}
    </Box>
  );
};

export default PerformingAssetsCreative;
